<template>
  <Card>
    <h1 slot="Title">Closed State</h1>
    <div slot="MainContent">
      <ul>
        <li>
          After the expired state, all remaining unobligated and unliquidated balances will be cancelled.
        </li>
      </ul>
      <ul>
        <li>
          The appropriation will no longer be available for obligation and/or disbursement.
        </li>
        <li>
          Any collections received will be deposited into a miscellaneous receipt account (021R3210.0001).
        </li>
        <li>
          Any obligations and adjustments will be charged to current appropriations.
        </li>
      </ul>
      <p>
        <b>Closed</b>: 1 Oct 2025 - Indefinitely
      </p>
    </div>
    <div slot="Notes">
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">Closed State</span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">REF: 37-100&gt;22-FY-3&nbsp;</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">CLOSED.&nbsp;</span></span><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255);">&nbsp; After the expired state, all remaining unobligated and unliquidated balances will be cancelled. &nbsp;The appropriation will no longer be available for obligation and disbursement for any purpose after cancellation (closing). &nbsp;After an appropriation is closed, any collections received will be deposited into a Miscellaneous Receipt Account (021R3210.0001). &nbsp;Any obligations and adjustments for cancelled accounts will be charged to current appropriations available for the same purpose. </span></p>
    </div>
  </Card>
</template>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'TestPage',
  
  data() {
    return {
    }
  }
  
}
</script>